import placeholder from "../assets/images/placeholder.png"

export default (image) => {
  if (typeof image !== "string" && image !== null) return image
  else if (image === null) return placeholder

  return image
}
